var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIHome = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.014 -4.144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.241,14.856H8.9V11.175a.107.107,0,0,0-.107-.107H7.2a.107.107,0,0,0-.106.107v3.681H3.761a1.248,1.248,0,0,1-1.248-1.248V8.913a.509.509,0,1,1,1.017,0v4.819a.106.106,0,0,0,.106.107H6.077V11.3a1.249,1.249,0,0,1,1.248-1.248H8.666A1.248,1.248,0,0,1,9.914,11.3v2.539h2.453a.108.108,0,0,0,.107-.107V8.913a.507.507,0,1,1,1.014,0v4.695A1.248,1.248,0,0,1,12.241,14.856Zm2.238-6.293a.5.5,0,0,1-.354-.143L8,2.553,1.872,8.422a.554.554,0,0,1-.362.141.493.493,0,0,1-.355-.156.513.513,0,0,1,.011-.718L8,1.144l6.831,6.544a.514.514,0,0,1,.017.718.507.507,0,0,1-.36.157Zm-1.5-3.614a.509.509,0,0,1-.509-.509V3.118a.108.108,0,0,0-.107-.106H11.127a.509.509,0,1,1,0-1.017h1.114a1.249,1.249,0,0,1,1.248,1.248v1.2A.508.508,0,0,1,12.982,4.949Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_home.3ea6edbf.svg";
export { ForwardRef as ReactComponent };